import { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] shadow-2xl hidden lg:block"
      style={{ backgroundColor: '#2d6142' }}
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-4 md:py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm md:text-base text-white/90 text-center sm:text-left flex-1">
          We use cookies to enhance your browsing experience and analyse site traffic. By clicking "Accept", you consent to our use of cookies.{' '}
          <a
            href="/contact"
            className="underline hover:no-underline text-white font-medium"
          >
            Learn more
          </a>
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-5 py-2 rounded-lg text-sm font-medium transition-all hover:opacity-80 border border-white/40 text-white"
            data-testid="cookie-decline-btn"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2 rounded-lg text-sm font-medium transition-all hover:opacity-90 text-white"
            style={{ backgroundColor: '#81b956' }}
            data-testid="cookie-accept-btn"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
